<template>
    <hm-content>
        <div class="table-panel flex">
            <div>
                <el-radio-group
                        v-model="searchCondition.changeStatus"
                        size="small"
                        @change="switchTab"
                >
                    <el-radio-button label="">全部({{changeStatusContent.auditWait + changeStatusContent.changeWait + changeStatusContent.changeDo + changeStatusContent.refuse}})</el-radio-button>
                    <el-radio-button label="changeWait"
                    >待换货({{changeStatusContent.changeWait}})</el-radio-button
                    >
                    <el-radio-button label="changeDo"
                    >已换货({{changeStatusContent.changeDo}})</el-radio-button
                    >

                    <el-radio-button label="refuse"
                    >已驳回({{changeStatusContent.refuse}})</el-radio-button
                    >

                    <el-radio-button label="auditWait"
                    >待审核({{changeStatusContent.auditWait}})</el-radio-button
                    >
                </el-radio-group>
            </div>
        </div>
            <div class="table-panel flex flex-end">
                <el-select v-model="conditionQuery.shopId" placeholder="请选择门店" class="mr10" size="small" filterable clearable>
                    <el-option
                         :label="item.shopName"
                         :value="item.shopId"
                         v-for="(item,index) in microShopStoreList"
                         :key="index"
                    >
                    </el-option>
                </el-select>
                <el-select v-model="conditionQuery.changeStatus" placeholder="请选择换货状态"  class="mr10" size="small">
                    <el-option
                            v-for="(item,index) in refundWay"
                            :label="item.value"
                            :value="item.key"
                            :key = "index"
                    >
                    </el-option>
                </el-select>
                <el-date-picker
                        v-model="queryDataTime"
                        type="daterange"
                        align="right"
                        start-placeholder="申请时间区间"
                        end-placeholder="结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        size="small"
                        class="mr10"
                ></el-date-picker>
                <el-input class="mr10" size="small" placeholder="请输入订单号/换货编号" v-model="conditionQuery.queryWord"></el-input>
                <el-button  class="mr10" size="small" type="primary" @click="queryList">查询</el-button>
                <el-button  class="mr10"
                            size="small"
                            type="primary"
                            @click="output"
                            :loading="isOutputing">导出</el-button>
                <el-button  class="mr10" size="small" type="info" @click="reset">重置</el-button>
            </div>
        <div>
            <el-table
                    :data="pageTableData"
                    stripe
                    style="width: 100%"
            >
                <el-table-column
                    header-align="center"
                    align="center"
                    label="序号"
                    type="index"
                    :index="index => index + (currentPage - 1) * pageSize + 1"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="changeSn"
                        label="换货编号"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        label="换货方式"
                >
                    <template>换货</template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="receiptSn"
                        label="订单编号"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="goodsName"
                        label="被换商品名称"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="goodsNum"
                        label="被换商品数量"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        label="被换商品金额"
                >
                    <template slot-scope="scope">
                        <span>￥{{scope.row.changeWxshopPrice}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="goodsSn"
                        label="商品编码"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="barCode"
                        label="商品条码"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="changeGoodsName"
                        label="申请换货商品"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="goodsNum"
                        label="申请换货商品数量"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        label="申请换货商品金额"
                >
                    <template slot-scope="scope">
                        <span>￥{{scope.row.wxshopPrice}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="changeSendTime"
                        label="申请时间"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="changeStatus"
                        label="换货状态"
                >
                    <template slot-scope="scope">
                        <span v-if = "scope.row.changeStatus === 'auditWait' " style="color: #0081E5">待审核</span>
                        <span v-if = "scope.row.changeStatus === 'changeWait' " style="color: #0081E5">待换货</span>
                        <span v-if = "scope.row.changeStatus === 'changeDo' "  style="color: #9999">已换货</span>
                        <span v-if = "scope.row.changeStatus === 'refuse' "  style="color:red">已驳回</span>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="shopName"
                        label="所属门店"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        label="操作"
                >
                    <template slot-scope="scope">
                        <el-button style="border: none; background: none; color: #0081E5" size="mini" icon="el-icon-view" v-model="scope.row" @click="checkExchangeGood(scope)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="hm-pagination">
                <el-pagination
                        background
                        :total="total"
                        @current-change="paging"
                        @size-change="handleSizeChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="currentPage"
                ></el-pagination>
            </div>
        </div>
        <el-dialog
                :visible.sync="dialogFormVisible"
                :close-on-click-modal="false"
                width="1560px"
        >
            <div slot="title">
                <span class="mr10">换货详情</span>
            </div>
            <div class="content">
                <div class="progress">
                    <el-steps :active="active" align-center  class="progress">
                        <el-step title="发起申请" :description="pageTableData[0].changeSendTime" v-if="pageTableData.length !== 0"></el-step>
                        <el-step title="核定信息" :description="timeXQ.auditWait !== ''? dateFormat(timeXQ.auditWait,'Y-m-d H:i:s') : ''"></el-step>
                        <el-step title="确认换货" :description="timeXQ.changeWait !== '' ? dateFormat(timeXQ.changeWait,'Y-m-d H:i:s') : ''"></el-step>
                        <el-step title="换货成功/驳回" :description="timeXQ.refuse !== '' || timeXQ.changeDo !== '' ? dateFormat(timeXQ.refuse,'Y-m-d H:i:s') || dateFormat(timeXQ.changeDo,'Y-m-d H:i:s') : ''"></el-step>
                    </el-steps>
                </div>
            </div>
            <div class="changge_msg">
                <div class="changge_msg_left">
                    <div class="title"><div class="icon"></div>被换商品信息</div>
                    <el-table
                            border
                            :data="[selectedChangeGood]"
                            size="small"
                    >
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="changeSn"
                                label="换货编号"
                        >
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                label="换货方式"
                        >
                            <template>换货</template>
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="receiptSn"
                                label="订单编号"
                        >
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="goodsName"
                                label="被换商品名称"
                        >
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="goodsNum"
                                label="被换商品数量"
                        >
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                label="被换商品金额"
                        >
                            <template slot-scope="scope">
                                <span>￥{{scope.row.changeWxshopPrice}}</span>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="title"><div class="icon"></div>商品信息</div>
                    <el-table
                            border
                            :data="detailsOrder.orderGoods"
                            size="small"
                    >
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="goodsImg"
                                label="商品图片"
                                width="150"
                        >
                            <template slot-scope="scope">
                                <div>
                                    <div
                                            class="flex bd-goodsinfo table-p10"
                                            style="position:absolute;"
                                    >
                                        <div
                                            class="flex-around"
                                        >
                                            <div
                                                    class="flex flex-center item-center"
                                                    v-if="scope.row.returnType !== 'no'"
                                            >
                                                <!-- 换货 -->
                                                <img
                                                        v-if="scope.row.changeStatus === 'auditWait' || scope.row.changeStatus === 'changeWait' || scope.row.changeStatus === 'changeDo' "
                                                        style="width:100px;height:100px"
                                                        src="https://imgcdn.hemiao100.com/hemiaoBase/81d2994f64c85809bf951f14fd56ecc.png"
                                                        alt=""
                                                />
                                                <!-- 仅退款 -->
                                                <img
                                                        v-if="scope.row.refundReturnType === 'money'"
                                                        style="width:100px;height:100px"
                                                        src="https://imgcdn.hemiao100.com/hemiaoBase/81d2994f64c85809bf951f14fd56ecc.png"
                                                        alt=""
                                                />

                                                <!-- 退货退款 -->
                                                <img
                                                        v-if="scope.row.refundReturnType === 'refund'"
                                                        style="width:100px;height:100px"
                                                        src="https://imgcdn.hemiao100.com/hemiaoBase/8088827e177ba800a9eba2c17e295c8.png"
                                                        alt=""
                                                />

                                                <!-- 退运费 -->
                                                <img
                                                        v-if="scope.row.refundReturnType === 'deliver'"
                                                        style="width:100px;height:100px"
                                                        src="https://imgcdn.hemiao100.com/hemiaoBase/9a0ad12b4cead9d04371c126a61d5d5.png"
                                                        alt=""
                                                />
                                            </div>
                                        </div>
                                    </div>


                                    <div
                                            class="flex flex-center item-center"
                                    >
                                        <img
                                                style="width:100px;height:100px;"
                                                v-if="scope.row.goodsImg"
                                                :src="scope.row.goodsImg"
                                                alt=""
                                        />
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="spuName"
                                label="商品名称/品牌"
                        >
                            <template slot-scope="scope">
                                <el-tooltip
                                        class="item"
                                        :content="scope.row.spuName"
                                        placement="top"
                                >
                                    <div class="flex item-center">
                                        <!-- <span class="pos" v-if="scope.row.createMode">
                                        p
                                      </span> -->

                                        <span class="time flex-1 text-overflow">
                            {{ scope.row.spuName }}
                          </span>
                                    </div>
                                </el-tooltip>
                                <div>品牌: {{ scope.row.brandName }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="spuName"
                                label="价格/货号"
                        >
                            <template slot-scope="scope">
                                <p>价格: {{ scope.row.totalPrice }}</p>
                                <p>货号: {{ scope.row.goodsSn }}</p>
                                <p>条码: {{ scope.row.barCode }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="spuName"
                                label="净重/毛重"
                        >
                            <template slot-scope="scope">
                                <p v-if="scope.row.netWeight">
                                    净重: {{ scope.row.netWeight }}
                                </p>
                                <p v-if="scope.row.grossWeight">
                                    毛重: {{ scope.row.grossWeight }}
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="specIdGroupName"
                                label="规格"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="goodsNum"
                                label="数量"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="totalPrice"
                                label="小计"
                        >
                            <template slot-scope="scope">
                                <p>
                                    {{
                                    (scope.row.totalPrice * scope.row.goodsNum).toFixed(2)
                                    }}
                                </p>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="title"><div class="icon"></div>订单信息</div>
                    <el-table
                            stripe
                            border
                            :data="detailsOrder.order"
                            size="small"
                            class="table_margin"
                    >
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="receiptSn"
                                label="订单号"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="spuName"
                                label="发货单流水号"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="memberMobile"
                                label="会员手机号"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="payMode"
                                label="支付方式"
                        >
                            <template slot-scope="scope">
                        <span
                                class="status danger"
                                v-if="scope.row.payMode === 'no_pay'"
                        >未支付</span
                        >
                                <span
                                        class="status danger"
                                        v-if="scope.row.payMode === '0_pay'"
                                >0元订单</span
                                >
                                <span
                                        class="status danger"
                                        v-if="scope.row.payMode === 'wx_pay'"
                                >微信支付</span
                                >
                                <span
                                        class="status danger"
                                        v-if="scope.row.payMode === 'ali_pay'"
                                >支付支付</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="orderSource"
                                label="订单来源"
                        >
                            <template slot-scope="scope">
                        <span v-if="scope.row.orderSource === 'wxShop'"
                        >微店订单</span
                        >
                            </template>
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="orderType"
                                label="订单类型"
                        >
                            <template slot-scope="scope">
                        <span v-if="scope.row.orderType === 'wshop'"
                        >微店订单</span
                        >
                                <span v-if="scope.row.orderType === 'ptdd'"
                                >拼团订单</span
                                >
                                <span v-if="scope.row.orderType === 'kjdd'"
                                >砍价订单</span
                                >
                                <span v-if="scope.row.orderType === 'mshd'"
                                >秒杀订单</span
                                >
                                <span v-if="scope.row.orderType === 'smg_faceToFace'"
                                >代客下单-当面收款</span
                                >
                                <span v-if="scope.row.orderType === 'smg_netPush'"
                                >代客下单-网络推送</span
                                >
                                <span v-if="scope.row.orderType === 'dhdd'"
                                >兑换订单</span
                                >
                                <span v-if="scope.row.orderType === 'integral_order'"
                                >积分兑换订单</span
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-table
                            class="table_margin"
                            stripe
                            border
                            :data="detailsOrder.order"
                            size="small"
                    >
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="deliveryType"
                                label="配送方式"
                        >
                            <template slot-scope="scope">
                        <span v-if="scope.row.deliveryType === 'mdzt'"
                        >门店自提</span
                        >
                                <span v-if="scope.row.deliveryType === 'kdfh'"
                                >快递发货</span
                                >
                                <span v-if="scope.row.deliveryType === 'tcps'"
                                >同城配送</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="detailsOrder.orderGoods.deliveryType === 'mdzt'"
                                header-align="center"
                                align="center"
                                prop="billNo"
                                label="提货单号"
                        ></el-table-column>
                        <el-table-column
                                v-else
                                header-align="center"
                                align="center"
                                prop="expressOrderSn"
                                label="物流单号"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="spuName"
                                label="自动确认收货时间"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="shopName"
                                label="指定信息"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="orderRemark"
                                label="订单备注"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="spuName"
                                label="活动信息"
                        ></el-table-column>
                    </el-table>
                    <div class="title"><div class="icon"></div>收货人信息</div>
                    <el-table
                            stripe
                            border
                            :data="detailsOrder.order"
                            size="small"
                    >
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="receiverName"
                                label="收货人"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="receiverMobile"
                                label="手机号码"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="spuName"
                                label="邮政编码"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="deliveryAddress"
                                label="收货地址"
                        >
                            <template slot-scope="scope">
                      <span
                      >{{ scope.row.deliveryProvince
                        }}{{ scope.row.deliveryAddress }}</span
                      >
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="title"><div class="icon"></div>操作信息</div>
                    <el-table
                            stripe
                            border
                            :data="detailsOrder.orderStatus"
                            size="small"
                    >
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="operatorAccount"
                                label="操作账号"
                        >
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="operatorName"
                                label="操作人"
                        >
                            <template slot-scope="scope">
                                <div v-if="scope.row.operatorName === null">
                                    {{ scope.row.createBy }}
                                </div>
                                <div v-else>
                                    {{ scope.row.operatorName }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="createTime"
                                label="操作时间"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="spuName"
                                label="订单状态"
                        >
                            <template slot-scope="scope">
                      <span
                              class="status blue"
                              v-if="scope.row.orderStatus === 'createOrder'"
                      >待付款</span
                      >
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'payOrder'"
                                >待发货</span>
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'deliverOrder'"
                                >已发货</span>
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'takeOrder'"
                                >已收货</span>
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'pushOrder'"
                                >已评价</span>
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'delOrder'"
                                >已取消</span>
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'returnOrder'"
                                >有退货退款</span>
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'rejectOrder'"
                                >驳回申请</span>
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'changeDo' || scope.row.orderStatus === 'refuse'"
                                >有换货</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="spuName"
                                label="付款状态"
                        >
                            <template slot-scope="scope">
                      <span
                              class="status blue"
                              v-if="scope.row.orderStatus === 'createOrder'"
                      >未付款</span
                      >
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'payOrder'"
                                >已付款</span
                                >
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'deliverOrder'"
                                >已付款</span
                                >
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'takeOrder'"
                                >已付款</span
                                >
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'pushOrder'"
                                >已付款</span
                                >
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'delOrder'"
                                >已取消</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="spuName"
                                label="发货状态"
                        >
                            <template slot-scope="scope">
                      <span
                              class="status blue"
                              v-if="scope.row.orderStatus === 'createOrder'"
                      >未发货</span
                      >
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'payOrder'"
                                >未发货</span
                                >
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'deliverOrder'"
                                >已发货</span
                                >
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'takeOrder'"
                                >已发货</span
                                >
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'pushOrder'"
                                >已发货</span
                                >
                                <span
                                        class="status blue"
                                        v-if="scope.row.orderStatus === 'delOrder'"
                                >已取消</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="remark"
                                label="备注"
                        ></el-table-column>
                    </el-table>
                </div>
                <div class="changge_msg_right">
                    <div class="title"><div class="icon"></div>换货审核</div>
                        <el-table
                                stripe
                                border
                                :data="dataillist"
                                size="small"
                        >
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="changeSn"
                                    label="换货编码"
                            >
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="goodsName"
                                    label="商品名称"
                            >
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="changeGoodsName"
                                    label="申请换货商品"
                            ></el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="goodsNum"
                                    label="商品数量"
                            >
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="goodsNum"
                                    label="小计"
                            >
                                <template slot-scope="scope">
                                    <span>￥{{scope.row.wxshopPrice * scope.row.goodsNum}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                        header-align="center"
                                        align="center"
                                        prop="changeStatus"
                                        label="换货状态"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.changeStatus === 'auditWait'">待审核</span>
                                    <span v-if="scope.row.changeStatus === 'changeWait'">待换货</span>
                                    <span v-if="scope.row.changeStatus === 'changeDo'">已换货</span>
                                    <span v-if="scope.row.changeStatus === 'refuse'">已驳回</span>
                                    <span v-if="scope.row.changeStatus === 'allowChange'">允许换货</span>
                                </template>
                             </el-table-column>
                             <el-table-column
                                        header-align="center"
                                        align="center"
                                        label="操作"
                                >
                                 <template slot-scope="scope">
                                     <div v-if="scope.row.changeStatus == 'auditWait' || scope.row.changeStatus == 'allowChange'">
                                         <el-button
                                                 style="border: none; color: red;"
                                                 type="text"
                                                 size="small"
                                                 @click="agreementExchangeGood(scope,'changeWait')"
                                         >同意换货</el-button>
                                         <el-button
                                                 style="border: none; color: red;"
                                                 type="text"
                                                 size="small"

                                                 @click="causeFormVisible = true"
                                         >驳回</el-button>
                                     </div>
                                     <div v-else-if="scope.row.changeStatus == 'changeWait'">
                                         <el-button
                                                 style="border: none; color: red;"
                                                 type="text"
                                                 size="small"

                                                 @click="agreementExchangeGood(scope,'changeDo')"
                                         >确认换货</el-button>
                                         <el-button
                                                 style="border: none; color: red;"
                                                 type="text"
                                                 size="small"
                                                 @click="causeFormVisible = true"
                                         >驳回</el-button>
                                     </div>
                                     <span v-else>已审核</span>
                                     <el-dialog title="输入驳回原因" :visible.sync="causeFormVisible" append-to-body>
                                         <el-input
                                                 type="textarea"
                                                 placeholder="请输入驳回原因"
                                                 style="margin-bottom: 20px"
                                                 v-model="editPrams.changeContext">
                                         </el-input>
                                         <el-button @click="causeFormVisible = false">取消</el-button>
                                         <el-button @click="agreementExchangeGood(scope,'refuse')" type="primary">确认驳回</el-button>
                                     </el-dialog>
                                 </template>
                             </el-table-column>
                        </el-table>
                    <div class="title"><div class="icon"></div>换货信息</div>
                    <el-table
                        :data="operationRecord"
                        stripe
                        border
                    >
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="operationType"
                                label="操作状态"
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.operationType === 'auditWait'">待审核</span>
                                <span v-if="scope.row.operationType === 'changeWait'">待换货</span>
                                <span v-if="scope.row.operationType === 'changeDo'">已换货</span>
                                <span v-if="scope.row.operationType === 'refuse'">已驳回</span>
                                <span v-if="scope.row.operationType === 'allowChange'">允许换货</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="operationRemark"
                                label="操作备注"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="operateTime"
                                label="操作时间"
                        ></el-table-column>
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="operator"
                                label="操作人"
                        ></el-table-column>
                    </el-table>
                </div>
            </div>
            <div style="width: 100%; text-align: center">
                <el-button style="margin-top: 12px;" @click="closeW" type="primary">关闭</el-button>
            </div>

        </el-dialog>
    </hm-content>
</template>
<script>
import { mapGetters } from "vuex";
import { outPutMixin } from "@/mixins/outputMixin";
import {getLoginUser} from "@/utils/auth";
import { setCookie, getCookie, formatFloat } from "@/utils/utils";
import moment from "moment";
export default {
        mixins: [outPutMixin],
        name: 'queryPageList',
        data(){
            return {
                timeXQ: {
                    changeDo:'',
                    changeWait:'',
                    auditWait:'',
                    refuse:''
                },
                isOutputing:false,
                dataTimeOption:[
                    {
                        value:'申请时间',
                        key:'changeSendTime'
                    },
                    {
                        value:'换货时间',
                        key:'changeTime'
                    }
                ],
                allShopList:[{}],
                causeFormVisible:false,
                exchangeGoodDetail:[{
                    goodsImg:'',
                    goodsName:'',
                    spuName:'',
                    specIdGroupName:'',
                    goodsNum:'',
                    totalPrice:''
                }],
                exchangeGoodOrderGoods:{
                  receiptSn:''
                },
                object:{
                  goodsImg:'',
                  spuName:'',
                  specIdGroupName: '',
                  goodsNum:'',
                  totalPrice:''
                },
                selectedChangeGood: {},
                active: 2,
                dialogTableVisible: false,
                dialogFormVisible: false,
                dataTime:'',
                queryDataTime:'changeSendTime',
                refundWay:[
                  {
                    key:'auditWait',
                    value:'待审核',
                    },
                   {
                    key:'changeWait',
                    value:'待换货'
                      },
                  {
                      key:'changeDo',
                      value:'已换货'
                  },
                  {
                      key:'refuse',
                      value:'已驳回'
                  }],
                formLabelWidth: '120px',
                conditionQuery: {  //条件查询
                  shopId:'',
                  changeStatus:'',
                  queryTimeType:'changeSendTime',
                  queryWord:''
                },
                editPrams:{
                 id:'',
                 changeStatus:'',
                 changeContext:'',
                },
                dataillist: [{}],
                operationRecord:[{
                    operateTime:''
                }],

                pageTableData:[{
                 changeSn:'', //換貨編碼
                 changeFs: '換貨',   //换货方式
                 receiptSn: '', //订单编号
                 goodsName: '',  //商品名称
                 goodsSn: '',  //商品编码
                 goodsNum: '',   //商品数量
                 barCode: '',  //商品条码
                 changeGoodsName: '', //申请换货商品
                 //goodsNum: '',   商品数量
                 changeSendTime: '', //换货申请时间
                 changeStatus: '',   //换货状态
                 shopName: '',   //所属门店
                 changeType: '',
                 orderId:''
                }],
                exchangeContent:'',
                searchCondition: {
                  changeStatus: '',   //换货状态
                },
                currentPage: 1,
                pageSize: 10,
                total:0,
                changeStatusContent:{
                    auditWait: 0,  //待审核
                    changeDo:0,  //  已换货
                    changeWait: 0,  //待换货
                    refuse:0, //已驳回
                    allStatus:0
                },
                contditionQuery: {
                  orderId:'',
                  id:''
                },
                detailsOrder: {
                    order:[],
                    orderGoods:[],
                    orderStatus:[]
                },
                detailsOrderMsg:'',
            }
        },
      computed: mapGetters([
         "auditExchange",
         "microShopStoreList",
      ]),
      mounted() {
          this.queryList();
          this.shopList();
      },
        methods:{
            dateFormat(timestamp, formats) {
                // formats格式包括
                // 1. Y-m-d
                // 2. Y-m-d H:i:s
                // 3. Y年m月d日
                // 4. Y年m月d日 H时i分
                formats = formats || 'Y-m-d';

                var zero = function (value) {
                    if (value < 10) {
                        return '0' + value;
                    }
                    return value;
                };

                var myDate = timestamp? new Date(timestamp): new Date();

                var year = myDate.getFullYear();
                var month = zero(myDate.getMonth() + 1);
                var day = zero(myDate.getDate());

                var hour = zero(myDate.getHours());
                var minite = zero(myDate.getMinutes());
                var second = zero(myDate.getSeconds());

                return formats.replace(/Y|m|d|H|i|s/ig, function (matches) {
                    return ({
                        Y: year,
                        m: month,
                        d: day,
                        H: hour,
                        i: minite,
                        s: second
                    })[matches];
                })
            },
          paging(page) {
              this.currentPage = page;
              this.queryList();
          },
          handleSizeChange(size) {
              this.currentPage = 1;
              this.pageSize = size;
              this.queryList();
          },
          search() {
              this.currentPage = 1;
              this.queryList();
          },
          checkExchangeGood(val){
              this.timeXQ.auditWait = '';
              this.timeXQ.changeWait = '';
              this.timeXQ.auditDo = '';
              this.timeXQ.refuse = '';
              this.selectedChangeGood = val.row;
              console.log(this.timeXQ);
              this.dialogFormVisible = true;
              this.goodlist(val);
              this.detaillistFun(val);
              this.exchangeOperationRecordFun(val);
              if(val.row.changeStatus  == "auditWait"){
                  this.active = 2;
              } else if (val.row.changeStatus  == "changeWait"){
                  this.active = 3;
              }else if(val.row.changeStatus  == "changeDo" || val.row.changeStatus  == "refuse"){
                  this.active = 4;
              };
              this.timeXQ.auditWait
          },
          isArray(arr) {
              return Object.prototype.toString.call(arr) === "[object Array]";
          },
          async switchTab() {
              this.currentPage = 1;
              let params = {
                  pageNo: this.currentPage,
                  pageSize: this.pageSize
              };
              const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
              Object.assign(params, searchCondition);
              const { result } = await this.$store.dispatch("exchangenGoodMsgPageList",params);
              const { records, total } = result.pageList;
              this.pageTableData = records;
              this.total = total;
          },
          reset(){
              this.conditionQuery.shopId = "";
              this.conditionQuery.changeStatus = "";
              this.conditionQuery.queryWord = "";
              this.queryDataTime = '';
              this.queryList();
          },
          async agreementExchangeGood(val,status){   //同意/驳回换货
              this.editPrams.id = val.row.id;
              this.editPrams.changeStatus = status;
              if(status == "refuse"){
                  this.causeFormVisible = true;
              };
              const params = JSON.parse(JSON.stringify(this.editPrams));
              await this.$store.dispatch("exchangenGoodDetailedit",params);
              this.$message('操作成功')
              this.detaillistFun(val);
              this.exchangeOperationRecordFun(val);
              this.queryList();
              this.causeFormVisible = false;
              if (this.operationRecord.operationType  == "changeWait"){
                  this.active = 3;
              }else if(this.operationRecord.operationType  == "changeDo" || this.operationRecord.operationType  == "refuse"){
                  this.active = 4;
              };
          },
          async goodlist(val){
              let params = {
                  orderId:val.row.orderId
              };
              const { result } = await this.$store.dispatch("detailOrder",params);
              let arr = [];
              arr.push(result.order);
              this.detailsOrder.order = arr;
              this.detailsOrder.orderGoods = result.orderGoods;
              this.detailsOrder.orderStatus = result.orderStatus;
          },
            //换货明细查询
          async detaillistFun(val){
              let params = {
                  pageNo: this.currentPage,
                  pageSize: this.pageSize
              };
              this.exchangeGoodOrderGoods.receiptSn = val.row.receiptSn
              const conditionQuery = JSON.parse(JSON.stringify(this.exchangeGoodOrderGoods));
              Object.assign(params,conditionQuery);
              const { result } = await this.$store.dispatch("exchangenGoodDetaillist",params);
              this.dataillist = result;
          },
          //换货操作纪录查询
          async exchangeOperationRecordFun(val){
              let params = {
                  pageNo: this.currentPage,
                  pageSize: this.pageSize
              };
              this.exchangeGoodOrderGoods.id = val.row.id;
              this.exchangeGoodOrderGoods.receiptSn = "";
              const conditionQuery = JSON.parse(JSON.stringify(this.exchangeGoodOrderGoods));
              Object.assign(params,conditionQuery);
              const { result } = await this.$store.dispatch("exchangeOperationRecord",params);
              console.log(result);
              this.operationRecord = result;
              if(this.operationRecord.length !== 0){
                  this.operationRecord.forEach(v =>{
                      console.log(v.operationType);
                      if(v.operationType == 'auditWait'){
                          this.timeXQ.auditWait = +new Date(v.operateTime) > this.timeXQ.auditWait ? +new Date(v.operateTime) : this.timeXQ.auditWait;
                      }else if(v.operationType == 'changeWait'){
                          this.timeXQ.changeWait = +new Date(v.operateTime) > this.timeXQ.changeWait ? +new Date(v.operateTime) : this.timeXQ.changeWait;
                      }else if(v.operationType == 'changeDo' || v.operationType == 'refuse'){
                          this.timeXQ.changeDo = +new Date(v.operateTime) > this.timeXQ.changeDo ? +new Date(v.operateTime) : this.timeXQ.changeDo;
                          this.timeXQ.refuse = +new Date(v.operateTime) > this.timeXQ.refuse ? +new Date(v.operateTime) : this.timeXQ.refuse;
                      }
                  });
              };

              console.log(this.timeXQ);
          },
          //换货列表查询
          async queryList(){
              let params = {
                  pageNo: this.currentPage,
                  pageSize: this.pageSize
              };
              const conditionQuery = JSON.parse(JSON.stringify(this.conditionQuery));
              if (this.isArray(this.queryDataTime)) {
                  conditionQuery.queryStartTime =
                      this.queryDataTime && this.queryDataTime.length > 0 ? this.queryDataTime[0]: "";
                  conditionQuery.queryEndTime =
                      this.queryDataTime && this.queryDataTime.length > 0 ? this.queryDataTime[1]: "";
              };
              Object.assign(params, conditionQuery);
              const { result } = await this.$store.dispatch("exchangenGoodMsgPageList",params);
              const { records, total } = result.pageList;
              this.changeStatusContent = result;
              this.pageTableData = records;
              this.total = total;
          },
            //查询门店信息
          async shopList(){
              const { result } = await this.$store.dispatch("queryMicroStoreList");
              this.allshopList = result;
          },
            output() {
                require.ensure([], () => {
                    const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
                    this.isOutputing = true;
                    const { storeCode } = getLoginUser();
                    let params = {
                        pageNo: this.currentPage,
                        pageSize: 9999999,
                        storeCode: storeCode,
                    };
                    const conditionQuery = JSON.parse(
                        JSON.stringify(this.conditionQuery)
                    );
                    if (this.isArray(this.queryDataTime)) {
                        conditionQuery.queryStartTime =
                            this.queryDataTime && this.queryDataTime.length > 0 ? this.queryDataTime[0]: "";
                        conditionQuery.queryEndTime =
                            this.queryDataTime && this.queryDataTime.length > 0 ? this.queryDataTime[1]: "";
                    };
                    Object.assign(params, conditionQuery);
                    this.$store
                        .dispatch("exchangenGoodMsgPageList", params)
                        .then((res) => {
                            const list = res.result.pageList.records;
                            list.forEach(v => {
                                v.haha = "换货状态";
                                v.change = "换货方式";
                                v.changeFs = "换货";
                                if (v.changeStatus == "auditWait") {
                                    v.changeStatus = "待审核";
                                } else if (v.changeStatus == "changeWait") {
                                    v.changeStatus = "待换货";
                                } else if (v.changeStatus == "changeDo") {
                                    v.changeStatus = "已换货";
                                } else if (v.changeStatus == "refuse") {
                                    v.changeStatus = "已驳回";
                                }
                            });
                            const tHeader = [
                                "换货编码",
                                "换货方式",
                                "订单编号",
                                "商品名称",
                                "商品数量",
                                "商品编码",
                                "商品条码",
                                "申请换货商品",
                                "申请换货商品数量",
                                "申请时间",
                                "换货状态",
                                "所属门店"
                            ];
                            const filterVal = [
                                "changeSn", //換貨編碼
                                "changeFs",   //换货方式
                                "receiptSn", //订单编号
                                "goodsName",  //商品名称
                                "goodsNum",   //商品数量
                                "goodsSn",  //商品编码
                                "barCode",  //商品条码
                                "changeGoodsName", //申请换货商品
                                "goodsNum",   //商品数量
                                "changeSendTime", //换货申请时间
                                "changeStatus",   //换货状态
                                "shopName"   //所属门店
                            ];
                            const data = this.formatJson(filterVal, list);
                            exportJsonToExcel(
                                tHeader,
                                data,
                                "换货订单" + new Date().toLocaleString()
                            );
                            this.isOutputing = false;
                        })
                        .catch(() => {
                            this.isOutputing = false;
                        });
                });
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map((v) => filterVal.map((j) => v[j]));
            },
            closeW(){
                this.dialogFormVisible = false;
            }
      }
    }
</script>
<style lang="scss" scoped>
.table_margin{
    margin: 10px 0 10px 0;
}
.changge_msg{
    width:1520px;
    margin-left: 32px;
    display: flex;
    justify-content: center;
    overflow: hidden;
    .el-dialog {
        margin: 0 auto !important;
        height: 90%;
        overflow: hidden;
        .el-dialog__body {
            position: absolute;
            left: 0;
            top: 54px;
            bottom: 0;
            right: 0;
            padding: 0;
            z-index: 1;
            overflow: hidden;
        }
    }
}
.changge_msg_left{
    margin-right: 18px;
}
.changge_msg_left,.changge_msg_right{
    float: left;
    width:740px;
}
.title{
    width: 740px;
    height: 42px;
    line-height: 42px;
    font-size: 14px;
    text-indent: 1em;
}
.icon{
    float: left;
    width: 4px;
    height: 16px;
    margin-top: 13px;
    background: #E50065;
    border-radius: 4px 0px 4px 0px;
}
</style>